/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
setTimeout(() => {
	const dropdownButton = document.querySelector('#dropdownButton');
	const dropdown = document.querySelector('#dropdown')
	dropdown.addEventListener('blur', () => {
		dropdown.classList.remove('open')
	})

	dropdownButton.addEventListener('click', () => {
		dropdown.classList.toggle('open')
	});
	if(dropdown.querySelector('.current-cat')){

		const actCategory = dropdown.querySelector('.current-cat').innerText;
		if(actCategory) {
			dropdownButton.innerText = actCategory;
		}
	}
	(function ($) {

		function render_map($el) {
			// var
			var $markers = $el.find('.marker');
			// vars
			var args = {
				zoom: 16,
				center: new google.maps.LatLng(0, 0),
				mapTypeId: google.maps.MapTypeId.ROADMAP
			};
			// create map
			var map = new google.maps.Map($el[0], args);
			// add a markers reference
			map.markers = [];
			// add markers
			$markers.each(function () {
				add_marker($(this), map);
			});
			// center map
			center_map(map);

			function center_single_point(latLng, map) {
				var bounds = new google.maps.LatLngBounds();
				var latlng = new google.maps.LatLng(latLng.lat, latLng.lng);
				bounds.extend(latlng);
				map.setCenter(bounds.getCenter());
				map.setZoom(16);
			}

		}

		function add_marker($marker, map) {
			// var
			var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
			var markerID = $marker.attr('data-id');

			// create marker
			var marker = new google.maps.Marker({
				position: latlng,
				map: map
			});

			// add to array
			map.markers.push(marker);

			$("#marker-click-" + markerID).on('click', function() {
				google.maps.event.trigger(marker, 'click');
			});


			// if marker contains HTML, add it to an infoWindow
			if ($marker.html()) {
				// create info window
				var infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});
				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', function () {
					infowindow.open(map, marker);
				});
			}
		}

		function center_map(map) {
			// vars
			var bounds = new google.maps.LatLngBounds();
			// loop through all markers and create bounds
			$.each(map.markers, function (i, marker) {
				var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
				bounds.extend(latlng);
			});
			// only 1 marker?
			if (map.markers.length == 1) {
				// set center of map
				map.setCenter(bounds.getCenter());
				map.setZoom(16);
			} else {
				// fit to bounds
				map.fitBounds(bounds);
			}
		}



		$(document).ready(function () {
			$('.acf-map').each(function () {
				render_map($(this));
			});
		});
	})(jQuery);

}, 500);

